import { render, staticRenderFns } from "./study.vue?vue&type=template&id=528ba056&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"
import style0 from "./study.vue?vue&type=style&index=0&id=528ba056&prod&lang=scss&scoped=true"
import style1 from "./study.vue?vue&type=style&index=1&id=528ba056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ba056",
  null
  
)

export default component.exports